var _defs, _circle, _circle2, _g, _path, _line, _rect, _rect2, _line2, _rect3, _line3, _rect4, _g2, _path2, _rect5, _rect6, _rect7, _rect8, _g3, _path3, _line4, _rect9, _rect0, _line5, _rect1, _line6, _rect10, _g4, _path4, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path5, _path6, _path7, _polygon, _polygon2, _polygon3, _rect17, _polygon4, _polygon5, _polygon6, _rect18, _rect19, _rect20, _path8, _rect21, _rect22, _rect23, _g5, _path9, _line7, _rect24, _rect25, _line8, _rect26, _line9, _rect27, _g6, _path0, _line0, _rect28, _rect29, _line1, _rect30, _line10, _rect31, _g7, _path1, _rect32, _rect33, _rect34, _rect35, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFindHouse = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "3c305dcd-fc8d-4b55-a00e-82dc73cd93c6",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 964.26,
  height: 486.72,
  viewBox: "0 0 964.26 486.72",
  ref: ref,
  "aria-labelledby": titleId
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "78f90e6d-b24a-44d2-9f86-3fdf1c79ab28",
  x1: 1001.2,
  y1: 623.61,
  x2: 1001.2,
  y2: 406.11,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a2d5f515-de48-4f00-acad-c4726f878aac",
  x1: 846.11,
  y1: 465.37,
  x2: 846.11,
  y2: 223.13,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "70d1009e-dace-48dc-ab15-aedd5e3b03e6",
  x1: 913.68,
  y1: 630.19,
  x2: 913.68,
  y2: 407.89,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "9d354d98-a887-4f91-9102-a75a5431dd3b",
  x1: 775.55,
  y1: 469.82,
  x2: 775.55,
  y2: 223.04,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ad5409f9-492b-4351-8333-b0e7b9fbef2b",
  x1: 868.85,
  y1: 666.48,
  x2: 868.85,
  y2: 518.27,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bff858af-3bff-4656-bc49-4e0ce7b6f418",
  x1: 716.56,
  y1: 479.18,
  x2: 716.56,
  y2: 314.11,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "9646795a-0dc7-4a1c-aa48-1a0444241a64",
  x1: 835.31,
  y1: 671.87,
  x2: 835.31,
  y2: 522.66,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e954bb2d-a63d-48e0-a08e-512ca674347f",
  x1: 694.5,
  y1: 482.21,
  x2: 694.5,
  y2: 316.57,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d9f3a3cc-a090-4b27-9824-db9019e9fbdf",
  x1: 546.26,
  y1: 486.33,
  x2: 546.26,
  y2: 235.33,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bebe624b-dd80-4bfd-b5fb-36f1f92addf2",
  x1: 622.57,
  y1: 508.79,
  x2: 622.57,
  y2: 390.79,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a99917ae-4a89-472a-9152-7d4c890b2f20",
  x1: 249.26,
  y1: 486.33,
  x2: 249.26,
  y2: 13.33,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3d13e601-7b74-41be-a4f6-2a2c5df3e3e7",
  x1: 250.26,
  y1: 175.33,
  x2: 250.26,
  y2: 2.37,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1919e53f-dd67-48bc-94b3-535fb113a6c8",
  x1: 257.43,
  y1: 684.36,
  x2: 257.43,
  y2: 560.8,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "595c306e-168d-4085-ab46-670711e52ff5",
  x1: 106.14,
  y1: 486.72,
  x2: 106.14,
  y2: 349.11,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c7fb197d-4001-483a-882b-f14ca460811a",
  x1: 208.43,
  y1: 684.36,
  x2: 208.43,
  y2: 560.8,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "6a841889-cb28-426a-925d-d1c1f8724da8",
  x1: 57.14,
  y1: 486.72,
  x2: 57.14,
  y2: 349.11,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "5c82545c-e5e3-4953-955f-bf0089f1e97a",
  x1: 221.48,
  y1: 685.85,
  x2: 221.48,
  y2: 561.46,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "53fdcf2b-8327-4d89-b36d-71a6ad642ea4",
  x1: 79.75,
  y1: 486.25,
  x2: 79.75,
  y2: 348.16,
  xlinkHref: "#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "2fa7ee9e-16f3-4285-a1b9-f91a38b07546",
  x1: 791.07,
  y1: 652.6,
  x2: 791.07,
  y2: 255.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b3b3b3",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#b3b3b3",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b3b3b3",
  stopOpacity: 0.05
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "1d6e68af-1823-4deb-b27c-c7781de2c421",
  x1: 668.29,
  y1: 396.98,
  x2: 668.29,
  y2: 377.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "4b1a7092-3747-45a4-a541-b9b6a299c3dc",
  x1: 756.12,
  y1: 375.04,
  x2: 756.12,
  y2: 316.56,
  xlinkHref: "#1d6e68af-1823-4deb-b27c-c7781de2c421"
}))), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "house searching") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 215.7,
  cy: 234.54,
  r: 182,
  fill: "none",
  stroke: "#ff9800",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  strokeDasharray: 12,
  opacity: 0.3
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 695.7,
  cy: 198.54,
  r: 182,
  fill: "none",
  stroke: "#ff9800",
  strokeMiterlimit: 10,
  strokeWidth: 4,
  strokeDasharray: 12,
  opacity: 0.3
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ff8ee4b4-5abc-4927-bead-5d69132ee8f9",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  d: "M912.36,518.33a45,45,0,0,1-12.22-30.79,45.71,45.71,0,0,1,22.42-39.07,26.53,26.53,0,0,1-4.68-15c0-15.09,12.66-27.32,28.28-27.32a28.15,28.15,0,0,1,27.13,19.67,42.43,42.43,0,0,1,36.08-19.67c23.27,0,42.14,18.23,42.14,40.71a39.4,39.4,0,0,1-2.58,14.05c.85-.06,1.71-.13,2.58-.13,18.68,0,33.82,14.63,33.82,32.68a31.94,31.94,0,0,1-.17,3.3c14.94,6.22,25.4,20.57,25.4,37.28,0,22.41-18.8,40.58-42,40.58a43.65,43.65,0,0,1-7.27-.62c.12,1.35.2,2.72.2,4.1,0,25.15-21.1,45.54-47.13,45.54a48,48,0,0,1-26.84-8.11,35.78,35.78,0,0,1-22.79,8.11c-19.45,0-35.21-15.23-35.21-34,0-.81.07-1.61.13-2.41h-.13c-20.82,0-37.7-16.31-37.7-36.43A36.3,36.3,0,0,1,912.36,518.33Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#78f90e6d-b24a-44d2-9f86-3fdf1c79ab28)"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "c200c6c4-addf-434c-9e0f-5ce7230e9a19",
  "data-name": "<Path>",
  d: "M916.17,518.18a43.1,43.1,0,0,1-11.69-29.47,43.75,43.75,0,0,1,21.46-37.4,25.39,25.39,0,0,1-4.48-14.39c0-14.44,12.12-26.15,27.07-26.15a27,27,0,0,1,26,18.82A40.62,40.62,0,0,1,1009,410.78c22.28,0,40.33,17.45,40.33,39a37.72,37.72,0,0,1-2.47,13.45c.82-.06,1.64-.12,2.47-.12,17.88,0,32.37,14,32.37,31.28a30.57,30.57,0,0,1-.17,3.16c14.3,6,24.31,19.69,24.31,35.68,0,21.45-18,38.84-40.2,38.84a41.78,41.78,0,0,1-7-.59c.12,1.29.19,2.6.19,3.92,0,24.07-20.2,43.58-45.11,43.58a46,46,0,0,1-25.69-7.76A34.25,34.25,0,0,1,966.3,619c-18.61,0-33.7-14.58-33.7-32.56,0-.78.06-1.54.12-2.31h-.12c-19.93,0-36.09-15.61-36.09-34.87A34.75,34.75,0,0,1,916.17,518.18Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#009688"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  id: "4f2fbb80-d4ec-4696-8eab-975803e285fc",
  "data-name": "<Path>",
  x1: 846.33,
  y1: 223.13,
  x2: 846.33,
  y2: 465.37,
  fill: "#795548"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 839.51,
  y: 223.13,
  width: 13.19,
  height: 242.23,
  fill: "url(#a2d5f515-de48-4f00-acad-c4726f878aac)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 842.68,
  y: 223.13,
  width: 7.3,
  height: 242.23,
  fill: "#795548"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  id: "964f69dd-bb5e-4ecb-a4f0-6b0cfaf1e31d",
  "data-name": "<Path>",
  x1: 847.07,
  y1: 295.68,
  x2: 803.81,
  y2: 251.56,
  fill: "#795548"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 968.09,
  y: 492.19,
  width: 7.3,
  height: 61.79,
  transform: "translate(-234.66 580.34) rotate(-44.43)",
  fill: "#795548"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  id: "72c4e71e-02d3-4be2-bc6f-3754e61bbdeb",
  "data-name": "<Path>",
  x1: 847.07,
  y1: 333.6,
  x2: 891.91,
  y2: 302.14,
  fill: "#795548"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 988.4,
  y: 563.68,
  width: 54.78,
  height: 7.3,
  transform: "translate(-287.88 436.96) rotate(-35.06)",
  fill: "#795548"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "09ddf46a-2bb3-497c-83d6-f7ff730d3d58",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  d: "M999.45,522.58a47.74,47.74,0,0,0-9.85-71.4,28.23,28.23,0,0,0,4.52-15.37c0-15.42-12.22-27.92-27.3-27.92a27.39,27.39,0,0,0-26.2,20.1,40.49,40.49,0,0,0-34.83-20.1c-22.47,0-40.69,18.63-40.69,41.61a42.37,42.37,0,0,0,2.49,14.36c-.82-.06-1.65-.13-2.49-.13-18,0-32.66,15-32.66,33.4,0,1.14.06,2.26.17,3.37a41.51,41.51,0,0,0-24.53,38.1c0,22.91,18.16,41.48,40.55,41.48a39.87,39.87,0,0,0,7-.63c-.12,1.38-.19,2.78-.19,4.19,0,25.7,20.37,46.54,45.51,46.54a44.59,44.59,0,0,0,25.91-8.29,33.4,33.4,0,0,0,22,8.29c18.78,0,34-15.57,34-34.77,0-.83-.07-1.65-.12-2.47h.12c20.11,0,36.4-16.67,36.4-37.23A37.32,37.32,0,0,0,999.45,522.58Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#70d1009e-dace-48dc-ab15-aedd5e3b03e6)"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "c2060184-c570-49c2-acda-2f80a9472e25",
  "data-name": "<Path>",
  d: "M994.19,522.36a44.81,44.81,0,0,0-9.25-67,26.5,26.5,0,0,0,4.24-14.43c0-14.48-11.47-26.21-25.63-26.21A25.71,25.71,0,0,0,939,433.58a38,38,0,0,0-32.7-18.87c-21.09,0-38.19,17.49-38.19,39.06a39.77,39.77,0,0,0,2.34,13.48c-.77-.06-1.55-.12-2.34-.12-16.93,0-30.65,14-30.65,31.35,0,1.07.05,2.12.16,3.16a39,39,0,0,0-23,35.77c0,21.5,17,38.93,38.07,38.93a37.43,37.43,0,0,0,6.59-.59c-.11,1.3-.18,2.61-.18,3.93,0,24.13,19.12,43.68,42.71,43.68a41.85,41.85,0,0,0,24.32-7.78,31.35,31.35,0,0,0,20.65,7.78c17.62,0,31.91-14.61,31.91-32.64,0-.78-.06-1.55-.11-2.32h.11c18.87,0,34.17-15.65,34.17-34.95A35,35,0,0,0,994.19,522.36Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#00897b"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 770.59,
  y: 223.04,
  width: 9.92,
  height: 246.78,
  fill: "url(#9d354d98-a887-4f91-9102-a75a5431dd3b)"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 773.41,
  y: 226.51,
  width: 4.99,
  height: 243.31,
  fill: "#795548"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 911.43,
  y: 524.78,
  width: 60.28,
  height: 4.99,
  transform: "translate(-231.37 610.35) rotate(-47.2)",
  fill: "#795548"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 897.36,
  y: 545.18,
  width: 4.99,
  height: 52.89,
  transform: "translate(-241.86 703.78) rotate(-53.4)",
  fill: "#795548"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "db20f295-6229-40c0-b196-6bb997b23afd",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  d: "M808.31,594.74a30.69,30.69,0,0,1-8.32-21,31.15,31.15,0,0,1,15.28-26.62,18.08,18.08,0,0,1-3.19-10.25c0-10.28,8.63-18.62,19.27-18.62a19.19,19.19,0,0,1,18.49,13.4,28.92,28.92,0,0,1,24.59-13.4c15.86,0,28.72,12.42,28.72,27.74a26.85,26.85,0,0,1-1.76,9.58c.58,0,1.16-.09,1.76-.09,12.73,0,23,10,23,22.27a21.77,21.77,0,0,1-.12,2.25,27.65,27.65,0,0,1,17.31,25.41c0,15.27-12.81,27.65-28.62,27.65a29.75,29.75,0,0,1-5-.42c.09.92.14,1.85.14,2.79,0,17.14-14.38,31-32.12,31A32.74,32.74,0,0,1,859.53,661,24.38,24.38,0,0,1,844,666.48c-13.25,0-24-10.38-24-23.18,0-.56,0-1.1.09-1.64H820c-14.19,0-25.69-11.11-25.69-24.82A24.74,24.74,0,0,1,808.31,594.74Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#ad5409f9-492b-4351-8333-b0e7b9fbef2b)"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  id: "3f6c00ca-74d6-4e4e-a4d6-8f160f37aa24",
  "data-name": "<Path>",
  d: "M810.9,594.64a29.37,29.37,0,0,1-8-20.08,29.81,29.81,0,0,1,14.63-25.48,17.3,17.3,0,0,1-3.05-9.81c0-9.84,8.26-17.82,18.44-17.82a18.36,18.36,0,0,1,17.7,12.83,27.68,27.68,0,0,1,23.53-12.83c15.18,0,27.49,11.89,27.49,26.56a25.7,25.7,0,0,1-1.68,9.17c.56,0,1.11-.08,1.68-.08,12.18,0,22.06,9.54,22.06,21.31a20.83,20.83,0,0,1-.11,2.15,26.47,26.47,0,0,1,16.57,24.32c0,14.62-12.27,26.47-27.4,26.47a28.47,28.47,0,0,1-4.74-.4c.08.88.13,1.77.13,2.67,0,16.4-13.76,29.7-30.74,29.7a31.34,31.34,0,0,1-17.5-5.29,23.34,23.34,0,0,1-14.86,5.29c-12.68,0-23-9.93-23-22.19,0-.53,0-1.05.08-1.57h-.08c-13.58,0-24.59-10.64-24.59-23.76A23.68,23.68,0,0,1,810.9,594.64Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#009688"
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  id: "8a7e076a-6ecd-440d-86c8-bd2eb9f9fc08",
  "data-name": "<Path>",
  x1: 716.71,
  y1: 314.11,
  x2: 716.71,
  y2: 479.18,
  fill: "#795548"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 712.06,
  y: 314.11,
  width: 8.99,
  height: 165.07,
  fill: "url(#bff858af-3bff-4656-bc49-4e0ce7b6f418)"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 714.22,
  y: 314.11,
  width: 4.97,
  height: 165.07,
  fill: "#795548"
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  id: "cd90862a-73c1-467f-8a8f-23aaf7962413",
  "data-name": "<Path>",
  x1: 717.21,
  y1: 363.55,
  x2: 687.74,
  y2: 333.48,
  fill: "#795548"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 846.29,
  y: 576.92,
  width: 4.97,
  height: 42.1,
  transform: "translate(-322.25 515.67) rotate(-44.43)",
  fill: "#795548"
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  id: "f406e355-8aa2-4ce0-9f47-8fc27dbb63cd",
  "data-name": "<Path>",
  x1: 717.21,
  y1: 389.39,
  x2: 747.77,
  y2: 367.95,
  fill: "#795548"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 860.13,
  y: 625.64,
  width: 37.33,
  height: 4.97,
  transform: "translate(-347.66 369.3) rotate(-35.06)",
  fill: "#795548"
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  id: "af04bae7-87e5-447e-b22a-307a28405780",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  d: "M892.88,599.64a32,32,0,0,0-6.61-47.92,19,19,0,0,0,3-10.32,18.28,18.28,0,0,0-35.91-5.25A27.18,27.18,0,0,0,830,522.66c-15.08,0-27.31,12.5-27.31,27.93a28.44,28.44,0,0,0,1.67,9.64c-.55,0-1.11-.09-1.67-.09a22.17,22.17,0,0,0-21.92,22.42c0,.76,0,1.52.11,2.26a27.86,27.86,0,0,0-16.46,25.58c0,15.37,12.19,27.84,27.22,27.84a26.76,26.76,0,0,0,4.71-.42c-.08.93-.13,1.86-.13,2.81,0,17.25,13.68,31.24,30.54,31.24a29.93,29.93,0,0,0,17.39-5.56,22.42,22.42,0,0,0,14.77,5.56,23.08,23.08,0,0,0,22.82-23.34c0-.56,0-1.11-.08-1.66h.08c13.5,0,24.44-11.19,24.44-25A25.05,25.05,0,0,0,892.88,599.64Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#9646795a-0dc7-4a1c-aa48-1a0444241a64)"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "e5433075-9388-42ed-900f-702a5a1be897",
  "data-name": "<Path>",
  d: "M889.35,599.5a30.08,30.08,0,0,0-6.21-45,17.79,17.79,0,0,0,2.85-9.68,17.16,17.16,0,0,0-33.71-4.93,25.51,25.51,0,0,0-21.95-12.66c-14.16,0-25.63,11.74-25.63,26.22a26.69,26.69,0,0,0,1.57,9.05c-.52,0-1-.08-1.57-.08a20.81,20.81,0,0,0-20.57,21c0,.72,0,1.43.1,2.12a26.15,26.15,0,0,0-15.45,24c0,14.43,11.44,26.13,25.55,26.13a25.12,25.12,0,0,0,4.42-.4c-.08.87-.12,1.75-.12,2.64,0,16.19,12.84,29.32,28.67,29.32a28.09,28.09,0,0,0,16.33-5.22,21,21,0,0,0,13.86,5.22,21.67,21.67,0,0,0,21.42-21.9c0-.52,0-1-.08-1.55h.08a23.2,23.2,0,0,0,22.94-23.46A23.51,23.51,0,0,0,889.35,599.5Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#00897b"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 691.17,
  y: 316.57,
  width: 6.66,
  height: 165.64,
  fill: "url(#e954bb2d-a63d-48e0-a08e-512ca674347f)"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 693.06,
  y: 318.9,
  width: 3.35,
  height: 163.31,
  fill: "#795548"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 833.8,
  y: 601.12,
  width: 40.46,
  height: 3.35,
  transform: "translate(-314.84 570.34) rotate(-47.2)",
  fill: "#795548"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 824.36,
  y: 614.81,
  width: 3.35,
  height: 35.5,
  transform: "translate(-320.6 669.12) rotate(-53.4)",
  fill: "#795548"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 405.26,
  y: 235.33,
  width: 282,
  height: 251,
  fill: "url(#d9f3a3cc-a090-4b27-9824-db9019e9fbdf)"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 220.26,
  y: 235.33,
  width: 460,
  height: 243,
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M848.57,508.79h-452v-118h435.5a16.5,16.5,0,0,1,16.5,16.5Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#bebe624b-dd80-4bfd-b5fb-36f1f92addf2)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M250.26,146H681.88a16.5,16.5,0,0,1,16.5,16.5v93.79a0,0,0,0,1,0,0H250.26a0,0,0,0,1,0,0V146A0,0,0,0,1,250.26,146Z",
  fill: "#009688"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M250.26,146H681.88a16.5,16.5,0,0,1,16.5,16.5v93.79a0,0,0,0,1,0,0H250.26a0,0,0,0,1,0,0V146A0,0,0,0,1,250.26,146Z",
  fill: "#fff",
  opacity: 0.7
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "249.26 13.32 93.26 123.18 93.26 215.75 93.26 486.32 405.26 486.32 405.26 215.75 405.26 123.18 249.26 13.32",
  fill: "url(#a99917ae-4a89-472a-9152-7d4c890b2f20)"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "398.26 121.33 250.26 13.32 102.26 121.33 102.26 212.32 398.26 212.32 398.26 121.33",
  fill: "#009688"
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  points: "398.26 121.33 250.26 13.32 102.26 121.33 102.26 212.32 398.26 212.32 398.26 121.33",
  fill: "#fff",
  opacity: 0.5
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 102.26,
  y: 212.33,
  width: 296,
  height: 266,
  fill: "#fff"
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  points: "417.26 175.32 250.26 56.07 81.26 175.32 70.26 133.38 250.26 2.37 430.26 133.38 417.26 175.32",
  fill: "url(#3d13e601-7b74-41be-a4f6-2a2c5df3e3e7)"
})), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
  points: "415.73 169.18 250.26 48.75 84.8 169.18 77.73 131.47 250.26 5.91 422.8 131.47 415.73 169.18",
  fill: "#009688"
})), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
  points: "415.73 169.18 250.26 48.75 84.8 169.18 77.73 131.47 250.26 5.91 422.8 131.47 415.73 169.18",
  opacity: 0.2
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 166.26,
  y: 270.33,
  width: 168,
  height: 208,
  fill: "#f2f2f2"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 166.26,
  y: 270.33,
  width: 168,
  height: 36,
  fill: "#009688"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 166.26,
  y: 442.33,
  width: 168,
  height: 36,
  fill: "#009688"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M677.9,653a1.5,1.5,0,0,0,0-3,1.5,1.5,0,0,0,0,3Z",
  transform: "translate(-146.3 -249.46)",
  fill: "lime"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 490.26,
  y: 326.33,
  width: 82,
  height: 152,
  fill: "#f2f2f2"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 593.26,
  y: 294.33,
  width: 77,
  height: 56,
  fill: "#f2f2f2"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 593.26,
  y: 294.33,
  width: 77,
  height: 25,
  fill: "#009688",
  opacity: 0.2
})), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  id: "47cb54cf-6c9b-4864-bf0d-76585f8d162f",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  d: "M207,624.55A25.58,25.58,0,0,1,200,607.06a26,26,0,0,1,12.74-22.19,15.07,15.07,0,0,1-2.66-8.54,15.8,15.8,0,0,1,16.06-15.52A16,16,0,0,1,241.58,572a24.11,24.11,0,0,1,20.5-11.17c13.22,0,23.94,10.36,23.94,23.13a22.39,22.39,0,0,1-1.47,8c.49,0,1-.07,1.47-.07,10.61,0,19.21,8.31,19.21,18.56a18.15,18.15,0,0,1-.1,1.87,23.05,23.05,0,0,1,14.43,21.18c0,12.73-10.68,23.05-23.86,23.05a24.8,24.8,0,0,1-4.13-.35c.07.77.11,1.54.11,2.33,0,14.29-12,25.87-26.77,25.87a27.29,27.29,0,0,1-15.25-4.61,20.33,20.33,0,0,1-12.95,4.61c-11,0-20-8.65-20-19.33,0-.46,0-.92.07-1.37h-.07c-11.83,0-21.42-9.27-21.42-20.69A20.62,20.62,0,0,1,207,624.55Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#1919e53f-dd67-48bc-94b3-535fb113a6c8)"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  id: "3ed80c62-65f0-4ea6-94fa-12b45cf1e111",
  "data-name": "<Path>",
  d: "M209.13,624.47a24.49,24.49,0,0,1-6.64-16.74,24.85,24.85,0,0,1,12.19-21.24,14.42,14.42,0,0,1-2.54-8.18,15.12,15.12,0,0,1,15.38-14.86,15.31,15.31,0,0,1,14.75,10.69,23.07,23.07,0,0,1,19.62-10.69c12.65,0,22.91,9.91,22.91,22.14a21.43,21.43,0,0,1-1.4,7.64c.46,0,.93-.07,1.4-.07,10.16,0,18.39,8,18.39,17.77a17.37,17.37,0,0,1-.09,1.79A22.07,22.07,0,0,1,316.9,633c0,12.19-10.22,22.07-22.84,22.07a23.73,23.73,0,0,1-4-.34c.07.73.11,1.48.11,2.23,0,13.67-11.47,24.76-25.63,24.76A26.12,26.12,0,0,1,250,677.3a19.45,19.45,0,0,1-12.39,4.41c-10.57,0-19.14-8.28-19.14-18.5,0-.44,0-.88.07-1.31h-.07c-11.32,0-20.5-8.87-20.5-19.81A19.74,19.74,0,0,1,209.13,624.47Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#009688"
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  id: "b49a21fb-81f1-4431-9ecd-ca46c91409d2",
  "data-name": "<Path>",
  x1: 106.27,
  y1: 349.11,
  x2: 106.27,
  y2: 486.72,
  fill: "#795548"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  x: 102.39,
  y: 349.11,
  width: 7.5,
  height: 137.61,
  fill: "url(#595c306e-168d-4085-ab46-670711e52ff5)"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  x: 104.19,
  y: 349.11,
  width: 4.14,
  height: 137.61,
  fill: "#795548"
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  id: "46369620-a42d-4543-9046-c39c6dd80f7a",
  "data-name": "<Path>",
  x1: 106.69,
  y1: 390.32,
  x2: 82.11,
  y2: 365.25,
  fill: "#795548"
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  x: 238.63,
  y: 609.7,
  width: 4.14,
  height: 35.1,
  transform: "translate(-516.59 98.36) rotate(-44.43)",
  fill: "#795548"
})), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  id: "062fca71-ec11-4619-a966-9015ca52f87c",
  "data-name": "<Path>",
  x1: 106.69,
  y1: 411.86,
  x2: 132.16,
  y2: 393.99,
  fill: "#795548"
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  x: 250.16,
  y: 650.31,
  width: 31.12,
  height: 4.14,
  transform: "translate(-472.83 21.54) rotate(-35.06)",
  fill: "#795548"
})), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  id: "a27ca12e-65b6-46c0-899b-83e3c1e240bd",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  d: "M158,624.55A25.58,25.58,0,0,1,151,607.06a26,26,0,0,1,12.74-22.19,15.07,15.07,0,0,1-2.66-8.54,15.8,15.8,0,0,1,16.06-15.52A16,16,0,0,1,192.58,572a24.11,24.11,0,0,1,20.5-11.17c13.22,0,23.94,10.36,23.94,23.13a22.39,22.39,0,0,1-1.47,8c.49,0,1-.07,1.47-.07,10.61,0,19.21,8.31,19.21,18.56a18.15,18.15,0,0,1-.1,1.87,23.05,23.05,0,0,1,14.43,21.18c0,12.73-10.68,23.05-23.86,23.05a24.8,24.8,0,0,1-4.13-.35c.07.77.11,1.54.11,2.33,0,14.29-12,25.87-26.77,25.87a27.29,27.29,0,0,1-15.25-4.61,20.33,20.33,0,0,1-12.95,4.61c-11,0-20-8.65-20-19.33,0-.46,0-.92.07-1.37h-.07c-11.83,0-21.42-9.27-21.42-20.69A20.62,20.62,0,0,1,158,624.55Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#c7fb197d-4001-483a-882b-f14ca460811a)"
}))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  id: "685c56b8-497f-4668-a7ee-09f5fbc3598c",
  "data-name": "<Path>",
  d: "M160.13,624.47a24.49,24.49,0,0,1-6.64-16.74,24.85,24.85,0,0,1,12.19-21.24,14.42,14.42,0,0,1-2.54-8.18,15.12,15.12,0,0,1,15.38-14.86,15.31,15.31,0,0,1,14.75,10.69,23.07,23.07,0,0,1,19.62-10.69c12.65,0,22.91,9.91,22.91,22.14a21.43,21.43,0,0,1-1.4,7.64c.46,0,.93-.07,1.4-.07,10.16,0,18.39,8,18.39,17.77a17.37,17.37,0,0,1-.09,1.79A22.07,22.07,0,0,1,267.9,633c0,12.19-10.22,22.07-22.84,22.07a23.73,23.73,0,0,1-4-.34c.07.73.11,1.48.11,2.23,0,13.67-11.47,24.76-25.63,24.76A26.12,26.12,0,0,1,201,677.3a19.45,19.45,0,0,1-12.39,4.41c-10.57,0-19.14-8.28-19.14-18.5,0-.44,0-.88.07-1.31h-.07c-11.32,0-20.5-8.87-20.5-19.81A19.74,19.74,0,0,1,160.13,624.47Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#009688"
})), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
  id: "6da80e84-a8c0-407e-a753-005b95fbf056",
  "data-name": "<Path>",
  x1: 57.27,
  y1: 349.11,
  x2: 57.27,
  y2: 486.72,
  fill: "#795548"
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  x: 53.39,
  y: 349.11,
  width: 7.5,
  height: 137.61,
  fill: "url(#6a841889-cb28-426a-925d-d1c1f8724da8)"
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  x: 55.19,
  y: 349.11,
  width: 4.14,
  height: 137.61,
  fill: "#795548"
})), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
  id: "956986cd-9b04-40a5-a6ac-3e412b0f623a",
  "data-name": "<Path>",
  x1: 57.69,
  y1: 390.32,
  x2: 33.11,
  y2: 365.25,
  fill: "#795548"
})), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  x: 189.63,
  y: 609.7,
  width: 4.14,
  height: 35.1,
  transform: "translate(-530.59 64.06) rotate(-44.43)",
  fill: "#795548"
})), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
  id: "52f85bb0-cc07-4469-ba3e-635298721117",
  "data-name": "<Path>",
  x1: 57.69,
  y1: 411.86,
  x2: 83.16,
  y2: 393.99,
  fill: "#795548"
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  x: 201.16,
  y: 650.31,
  width: 31.12,
  height: 4.14,
  transform: "translate(-481.72 -6.6) rotate(-35.06)",
  fill: "#795548"
})), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  id: "2b13a509-cfb1-48b6-9a8a-884e17259990",
  "data-name": "<Group>"
}, /*#__PURE__*/React.createElement("path", {
  d: "M269.47,625.64a26.71,26.71,0,0,0-5.51-40,15.8,15.8,0,0,0,2.53-8.6,15.24,15.24,0,0,0-29.94-4.38,22.66,22.66,0,0,0-19.49-11.25,23,23,0,0,0-22.77,23.28,23.71,23.71,0,0,0,1.39,8c-.46,0-.92-.07-1.39-.07A18.48,18.48,0,0,0,176,611.4c0,.64,0,1.27.09,1.89a23.23,23.23,0,0,0-13.72,21.32,23,23,0,0,0,22.69,23.21,22.31,22.31,0,0,0,3.93-.35c-.07.77-.11,1.55-.11,2.34,0,14.38,11.4,26,25.46,26a25,25,0,0,0,14.5-4.64,18.69,18.69,0,0,0,12.31,4.64,19.24,19.24,0,0,0,19-19.45c0-.47,0-.92-.07-1.38h.07a20.61,20.61,0,0,0,20.37-20.83A20.88,20.88,0,0,0,269.47,625.64Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#5c82545c-e5e3-4953-955f-bf0089f1e97a)"
}))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  id: "ffc97756-bf62-44e2-b6c0-20f8128ede8f",
  "data-name": "<Path>",
  d: "M266.53,625.52a25.07,25.07,0,0,0-5.18-37.5,14.83,14.83,0,0,0,2.37-8.07,14.3,14.3,0,0,0-28.1-4.11,21.27,21.27,0,0,0-18.3-10.56A21.62,21.62,0,0,0,196,587.14a22.25,22.25,0,0,0,1.31,7.54c-.43,0-.87-.07-1.31-.07a17.35,17.35,0,0,0-17.15,17.54c0,.6,0,1.19.09,1.77a21.8,21.8,0,0,0-12.88,20,21.55,21.55,0,0,0,21.3,21.78,20.94,20.94,0,0,0,3.69-.33c-.06.73-.1,1.46-.1,2.2,0,13.5,10.7,24.44,23.9,24.44a23.42,23.42,0,0,0,13.61-4.35A17.54,17.54,0,0,0,240,682a18.06,18.06,0,0,0,17.86-18.26c0-.44,0-.87-.06-1.3h.06a19.34,19.34,0,0,0,19.12-19.56A19.6,19.6,0,0,0,266.53,625.52Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#00897b"
})), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  x: 76.97,
  y: 348.16,
  width: 5.55,
  height: 138.09,
  fill: "url(#53fdcf2b-8327-4d89-b36d-71a6ad642ea4)"
})), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
  x: 78.55,
  y: 350.1,
  width: 2.79,
  height: 136.15,
  fill: "#795548"
})), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
  x: 220.22,
  y: 626.87,
  width: 33.73,
  height: 2.79,
  transform: "translate(-531.27 125.85) rotate(-47.2)",
  fill: "#795548"
})), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
  x: 212.35,
  y: 638.29,
  width: 2.79,
  height: 29.6,
  transform: "translate(-584.31 185.84) rotate(-53.4)",
  fill: "#795548"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M859.63,302.24a153,153,0,0,0-219-1.65c-57.91,58.38-58.89,153.43-2.25,213A153,153,0,0,0,834.6,535.28l110.6,115a7.44,7.44,0,0,0,10.53.21L983.28,624a7.44,7.44,0,0,0,.21-10.53l-110.6-115A153,153,0,0,0,859.63,302.24ZM825.18,487.16a109.43,109.43,0,1,1,3-154.73A109.43,109.43,0,0,1,825.18,487.16Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#2fa7ee9e-16f3-4285-a1b9-f91a38b07546)"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M668.29,377.85c-12.31,0-12.33,19.12,0,19.12S680.61,377.85,668.29,377.85Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#1d6e68af-1823-4deb-b27c-c7781de2c421)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M754.07,316.59c-33.12-.75-63.27,15.87-79.29,41-5.23,8.18,9.62,15.41,14.82,7.27,13.27-20.77,38.49-34,65.74-33.27,28.58.72,54.59,17.07,68.36,39.76,5.23,8.61,18.91.78,13.72-7.78C820.71,336,788.29,317.36,754.07,316.59Z",
  transform: "translate(-146.3 -249.46)",
  fill: "url(#4b1a7092-3747-45a4-a541-b9b6a299c3dc)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M871.63,296.42a153,153,0,0,0-219-1.65c-57.91,58.38-58.89,153.43-2.25,213A153,153,0,0,0,846.6,529.46l110.6,115a7.44,7.44,0,0,0,10.53.21l27.56-26.5a7.44,7.44,0,0,0,.21-10.53l-110.6-115A153,153,0,0,0,871.63,296.42ZM837.18,481.34a109.43,109.43,0,1,1,3-154.73A109.43,109.43,0,0,1,837.18,481.34Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#009688"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M680.29,372c-12.31,0-12.33,19.12,0,19.12S692.61,372,680.29,372Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#009688"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M766.07,310.77c-33.12-.75-63.27,15.87-79.29,41-5.23,8.18,9.62,15.41,14.82,7.27,13.27-20.77,38.49-34,65.74-33.27,28.58.72,54.59,17.07,68.36,39.76,5.23,8.61,18.91.78,13.72-7.78C832.71,330.2,800.29,311.55,766.07,310.77Z",
  transform: "translate(-146.3 -249.46)",
  fill: "#009688"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFindHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/find_house.d7c02a8434f978226e33d21af37cca99.svg";